import { Component, EventEmitter, Output, HostListener } from '@angular/core';
import { MainService } from '../../service/main.service';
import { session } from 'src/environments/environment.session';
import { Router } from '@angular/router';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';

import { AuthenticationService } from '../../../authentication.service';


@Component({
  selector: '[app-acms-sidebar]',
  templateUrl: './acms-sidebar.component.html',
  styleUrls: ['./acms-sidebar.component.css']
})
export class AcmsSidebarComponent {
  erpUser: any;
  user_id: any;
  imgURL: any;
  assigned_compoment: any = []
  sidebar: any = {}
  DATA_PORT_USER_IDS = [17856, 16012];
  constructor(

    private utf8EncodingService: Utf8EncodingService, private router: Router,
    private auth: AuthenticationService

  ) {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));

    this.assigned_compoment = this.erpUser?.assigned_component || [];

    this.sidebar['acms-index'] = !this.assigned_compoment.includes('ACMS-R1')
    this.sidebar['anganwadi'] = !this.assigned_compoment.includes('ACMS-R16')
    this.sidebar['anganwadi_center'] = !this.assigned_compoment.includes('ACMS-R3')
    this.sidebar['update-anganwadi'] = !this.assigned_compoment.includes('ACMS-R11')
    this.sidebar['assign_anganwadi'] = !this.assigned_compoment.includes('ACMS-R17')
    this.sidebar['master_data'] = !this.assigned_compoment.includes('ACMS-R18')
    this.sidebar['field'] = !this.assigned_compoment.includes('ACMS-R8')
    this.sidebar['code_value'] = !this.assigned_compoment.includes('ACMS-R9')
    this.sidebar['security'] = !this.assigned_compoment.includes('ACMS-R19')
    this.sidebar['roles'] = !this.assigned_compoment.includes('ACMS-R4')
    this.sidebar['acms_users'] = !this.assigned_compoment.includes('ACMS-R5')
    this.sidebar['data_assignment'] = !this.assigned_compoment.includes('ACMS-R6')
    this.sidebar['acms_appr'] = !this.assigned_compoment.includes('ACMS-R7')
    this.sidebar['hierarchy'] = !this.assigned_compoment.includes('ACMS-R10')
    this.sidebar['report'] = !this.assigned_compoment.includes('ACMS-R13')
    this.sidebar['fin_year'] = !this.assigned_compoment.includes('ACMS-R20')
    this.sidebar['freq_config'] = !this.assigned_compoment.includes('ACMS-R21')
    this.sidebar['anganwadi_report'] = !this.assigned_compoment.includes('ACMS-R14')
    this.sidebar['track_task'] = !this.assigned_compoment.includes('ACMS-R12')
    this.sidebar['survey_report'] = !this.assigned_compoment.includes('ACMS-R15')
    this.sidebar['profile'] = !this.assigned_compoment.includes('ACMS-R22')
    this.sidebar['darpan_data'] = !this.DATA_PORT_USER_IDS.includes(Number(this.erpUser?.le_id));
  }

  @Output() sidebarToggled = new EventEmitter<boolean>();
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
    this.updateCollapseState();
  }

  isCollapsed: boolean = window.innerWidth <= 992;
  innerWidth: number = window.innerWidth;
  dropdownOpen: string | null = null;
  dropcanvaOpen: string | null = null;



  ngOnInit(): void {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.sidebar['darpan_data'] = !this.DATA_PORT_USER_IDS.includes(Number(this.erpUser?.le_id));
  }
  goToIndex() {
    this.router.navigate(['/index'])
  }


  updateCollapseState() {
    if (this.innerWidth <= 992) {
      // Tablet or smaller → collapse
      this.isCollapsed = true;
    } else {
      // Desktop → expand
      this.isCollapsed = false;
    }
    if (this.innerWidth > 575) {
      document.getElementById('offcanvasclose')?.click();
    }
    this.sidebarToggled.emit(this.isCollapsed)
    this.dropdownOpen = null
    this.dropcanvaOpen = null
  }

  toggleCollapse() {
    if (this.innerWidth <= 992) {
      this.isCollapsed = !this.isCollapsed;
      if (this.dropdownOpen) {
        this.dropdownOpen = null
      }
    }
    this.sidebarToggled.emit(this.isCollapsed)
  }

  toggleDropdown(name: string, isHeaderClick: boolean = true) {
    const desktopWidth = 992;

    if (window.innerWidth < desktopWidth) {
      // 📱 Mobile/tablet
      if (this.isCollapsed) {
        this.isCollapsed = false;
      }

      if (isHeaderClick) {
        // Toggle the dropdown when header clicked
        if (this.dropdownOpen === name) {
          this.dropdownOpen = null;
          this.isCollapsed = true;
        } else {
          this.dropdownOpen = name;
        }
      } else {
        // Child clicked → close sidebar for mobile view
        this.isCollapsed = true;
        this.dropdownOpen = null;
      }

    } else {
      // 💻 Desktop
      this.isCollapsed = false;

      if (isHeaderClick) {
        // Toggle dropdown open/close
        if (this.dropdownOpen === name) {
          this.dropdownOpen = null;
        } else {
          this.dropdownOpen = name;
        }
      }
    }
    this.sidebarToggled.emit(this.isCollapsed)
  }


  onSubmenuToggle(open: string) {
    if (this.dropcanvaOpen === open) {
      this.dropcanvaOpen = null;
    } else {
      this.dropcanvaOpen = open;
    }
  }




  async logOut() {
    try {

      await this.auth.logout();
    } catch (e) { }
    sessionStorage.removeItem("1001");
    sessionStorage.removeItem("1000");
    sessionStorage.removeItem("1005");
    session.erpUser = undefined
    await this.router.navigate(['/login']);
  }

}
